<template>
  <div class="camp-course">
    <div class="top">
      <div class="input_div">
        <el-input v-model="query.product_name" placeholder="产品名称" clearable></el-input>
        <el-select v-model="query.is_online" placeholder="上架状态" clearable>
          <el-option label="上架" :value="1"></el-option>
          <el-option label="下架" :value="0"></el-option>
        </el-select>
        <el-select v-model="query.step_status" placeholder="流程状态" clearable>
          <el-option label="产品详情" value="1"></el-option>
          <el-option label="日期设置" value="2"></el-option>
          <el-option label="下单设置" value="3"></el-option>
          <el-option label="已完成" value="9"></el-option>
        </el-select>
        <div class="btns" @click="search">查询</div>
      </div>
      <div class="right_btn">
        <div class="outline" @click="openSignup()">报名信息</div>
        <div @click="openAdd">添加产品</div>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      :header-cell-style="tableHeaderColor"
      :cell-style="cellStyle"
      style="width:100%"
    >
      <el-table-column prop="no_product_ID" label="产品编号" min-width="160"></el-table-column>
      <el-table-column prop="product_name" label="产品名称" min-width="180"></el-table-column>
      <el-table-column label="封面" width="90">
        <template slot-scope="scope">
          <img v-if="coverUrl(scope.row)" :src="coverUrl(scope.row)" class="cover-img" alt="" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="营期数" width="90">
        <template slot-scope="scope">
          {{ (scope.row.product_date || []).length }}
        </template>
      </el-table-column>
      <el-table-column label="流程状态" width="110">
        <template slot-scope="scope">
          {{ stepText(scope.row.step_status) }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <span :class="scope.row.is_online == 1 ? 'states' : 'destates'">
            {{ scope.row.is_online == 1 ? '上架' : '下架' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" min-width="160"></el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <span class="tab_detail" @click="openEdit(scope.row)">编辑</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <span class="demonstration">共{{ total }}条记录，</span>
      <span class="demonstration">当前显示第{{ query.page }}页</span>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="query.page_size"
        :total="total"
        :current-page="query.page"
        @current-change="onPageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { campGetProductList } from '@/request/scenic.js'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        token: window.sessionStorage.getItem('Token'),
        product_type_id: 1,
        product_name: '',
        is_online: '',
        step_status: '',
        page: 1,
        page_size: 10
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    coverUrl(row) {
      let img = row.cover_img
      if (!img) return ''
      if (typeof img === 'string') {
        try {
          const arr = JSON.parse(img)
          return Array.isArray(arr) && arr[0] ? arr[0] : img
        } catch (e) {
          return img
        }
      }
      return Array.isArray(img) && img[0] ? img[0] : ''
    },
    stepText(v) {
      const map = { 1: '产品详情', 2: '日期设置', 3: '下单设置', 4: '退款设置', 9: '已完成' }
      return map[v] || map[String(v)] || '-'
    },
    search() {
      this.query.page = 1
      this.getList()
    },
    onPageChange(p) {
      this.query.page = p
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
        token: window.sessionStorage.getItem('Token'),
        product_type_id: this.query.product_type_id,
        page: this.query.page,
        page_size: this.query.page_size
      }
      if (this.query.product_name) params.product_name = this.query.product_name
      if (this.query.is_online !== '' && this.query.is_online != null) params.is_online = this.query.is_online
      if (this.query.step_status !== '' && this.query.step_status != null) params.step_status = this.query.step_status
      campGetProductList(params).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          const data = (res.data.result && res.data.result.data) || res.data.result || {}
          this.tableData = data.list || []
          this.total = data.total || 0
        } else {
          this.tableData = []
          this.total = 0
          if (res.data && res.data.msg) Message.error(res.data.msg)
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    openAdd() {
      this.$router.push({ path: '/campProduct' })
    },
    openSignup(row) {
      const query = {}
      if (row) {
        query.product_id = row.id || row.productID || row.product_id || ''
        query.product_name = row.product_name || ''
      }
      this.$router.push({ path: '/campSignup', query })
    },
    openEdit(row) {
      this.$router.push({
        path: '/campProduct',
        query: {
          id: row.id || row.productID || row.product_id,
          no_product_ID: row.no_product_ID || ''
        }
      })
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({ row, column, rowIndex, columnIndex })
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({ row, rowIndex })
    }
  }
}
</script>

<style lang="less" scoped>
.camp-course {
  .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
  }
  .input_div {
    display: flex;
    align-items: center;
    .el-input, .el-select {
      width: 18rem;
      margin-right: 1.6rem;
    }
    .btns {
      width: 11rem;
      height: 4rem;
      border-radius: 4px;
      background: #246DEB;
      color: #fff;
      font-size: 1.4rem;
      text-align: center;
      line-height: 4rem;
      cursor: pointer;
    }
  }
  .right_btn {
    display: flex;
    gap: 12px;
  }
  .right_btn > div {
    width: 11rem;
    height: 4rem;
    border-radius: 4px;
    font-size: 1.4rem;
    text-align: center;
    line-height: 4rem;
    cursor: pointer;
    background: #246DEB;
    border: 1px solid #246DEB;
    color: #fff;
    &.outline {
      background: #fff;
      color: #246DEB;
    }
  }
  .cover-img {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 4px;
  }
  .tab_detail {
    cursor: pointer;
    color: #246DEB;
  }
  .states { color: #4ECB73; }
  .destates { color: #E43535; }
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 42px auto;
    span {
      font-size: 14px;
      color: #000;
    }
  }
}
</style>
